/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'download': {
    viewBox: '0 0 32 32',
    data: '<g><path d="M24,11c-0.6,0-1,0.4-1,1s0.4,1,1,1h5v14H3V13h5c0.6,0,1-0.4,1-1s-0.4-1-1-1H1v18h30V11H24z"/><path d="M9.3,17.7l6.7,6.7l6.7-6.7c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0L17,20.6V4c0-0.6-0.4-1-1-1s-1,0.4-1,1v16.6l-4.3-4.3c-0.4-0.4-1-0.4-1.4,0S8.9,17.3,9.3,17.7z"/></g>'
  }
})
